import React from "react"
import { Box, Button, Typography } from "@mui/material"
import { ShowPreviewIcon } from "src/Icons/ShowPreviewIcon"

interface BottomBarProps {
  displayData: any;
  onButtonClick: () => void;
}

const BottomBar = ({
  displayData,
  onButtonClick,
}: BottomBarProps) => {

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        position: 'fixed',
        bottom: 0,
        zIndex: 2,
        background: 'white',
        maxHeight: '72px',
        minHeight: '72px',
        padding: '16px 20px',
        borderTop: '1px solid #F3F3F3',
        width: 'calc(100% - 270px)',
        marginLeft: '270px',
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: '400',
        }}
      >
        <span>You chose</span>
        <span style={{ color: '#BF295C', fontWeight: '600'}}>{` ${displayData} ${displayData === 1 ? 'service' : 'services'} `}</span>
        <span>for this studio</span>
      </Typography>

      <Button
        onClick={onButtonClick}
        variant="contained"
        disableElevation
        disableRipple
        disabled={displayData < 1}
        sx={{
          color: '#BF295C',
          padding: '0',
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          outline: 'none',
          background: 'transparent',
          '&:hover': {
            backgroundColor: 'transparent',
          },
          marginLeft: 'auto',
          gap: '8px',

          '&.Mui-disabled': {
            color: 'grey',
            backgroundColor: 'transparent',
          },
        }}
      >
        <Typography
          sx={{
            color: 'inherit',
            whiteSpace: "nowrap",
            fontSize: '14px',
            fontWeight: '600',
          }}
        >
            Show prewiev
        </Typography>
        <ShowPreviewIcon
          sx={{
            color: 'inherit',
            height: '15px',
            width: '15px',
          }}
        />
      </Button>
    </Box>
  )
}

export { BottomBar }